import Vue from 'vue';

Vue.component('budi-summary-index', () =>
    import(/* webpackChunkName: 'budi-summary-index' */ './budi-summary-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/budi-summary/index.js